module.exports = __webpack_public_path__ + "media/images/views/lp/icon/crown-icon-e6a7182bd28495a98e2290531443d260.png";